// Centralized query keys for React Query
export const QUERY_KEYS = {
  // Sections related keys
  // Include accountId so historical context (step 2) refetches when account changes
  SECTIONS: "sections:{tabId}:{meetingPrepId}:{email}:{accountId}",
  // Steps related keys
  STEPS: "steps",
  // Header related keys
  HEADER: "header",
  // Config related keys
  // Include accountId so config refetches when account changes
  CONFIG: "config:{email}:{accountId}",
  // Meetings related keys
  MEETINGS: "meetings:{email}",
  // Finalize review call related keys
  FINALIZE_REVIEW_CALL: "finalize_review_call:{meetingId}",
  // MAP progress related keys
  CALL_PLAN_PROGRESS: "call_plan_progress:{meetingId}:{step}",
  // Chat history related keys
  CHAT_HISTORY: "chat_history:{meetingId}",
  // Call scoring summary cards (call history page)
  CALL_SCORING_STATS: "call_scoring_stats:{email}:{startDate}:{endDate}",
  MANAGER_TEAM_STATS:
    "manager_team_stats:{managerEmail}:{startDate}:{endDate}",
  MANAGER_REPS:
    "manager_reps:{managerEmail}:{startDate}:{endDate}:{repName}:{page}:{pageSize}:{sortDir}",
  MANAGER_REP_OPTIONS: "manager_rep_options:{managerEmail}:{pageSize}",
  MANAGER_COACHING_FOCUS:
    "manager_coaching_focus:{accountId}:{repEmail}",
  MANAGER_REP_COACHING_FOCUS: "manager_rep_coaching_focus:{repEmail}",
  MANAGER_COACHING_EMAIL: "manager_coaching_email:{accountId}:{repEmail}",
  MANAGER_REP_BLOCKERS: "manager_rep_blockers:{repEmail}",
  MANAGER_ACCOUNT_STATS:
    "manager_account_stats:{managerEmail}:{startDate}:{endDate}",
  MANAGER_ACCOUNTS:
    "manager_accounts:{managerEmail}:{startDate}:{endDate}:{search}:{repEmail}:{momentumState}:{direction}",
  // Call history accounts table pagination
  CALL_SCORING_ACCOUNTS:
    "call_scoring_accounts:{email}:{startDate}:{endDate}:{search}",
  CALL_SCORING_ACCOUNT_HEADER:
    "call_scoring_account_header:{accountId}:{email}:{startDate}:{endDate}",
  CALL_SCORING_ACCOUNT_CALLS:
    "call_scoring_account_calls:{accountId}:{email}:{startDate}:{endDate}",
  CALL_SCORING_DRAFT_EMAIL: "call_scoring_draft_email:{meetingId}",
  DEAL_MOMENTUM: "deal_momentum:{meetingId}",
  // Super admin — sales rep directory & meetings
  ADMIN_SALES_REP_EMAILS: "admin_sales_rep_emails:{pageSize}",
  ADMIN_SALES_REP_MEETINGS: "admin_sales_rep_meetings:{emailId}:{pageSize}",
  ADMIN_MANAGERS: "admin_managers:{pageSize}",
} as const;

export const getQueryKey = (
  key: string,
  params?: Record<string, string | number>
) => {
  if (!params) return key;

  let result = key;
  Object.entries(params).forEach(([param, value]) => {
    result = result.replace(`{${param}}`, String(value));
  });

  return result;
};
